import { HeadPositionParam } from 'api/types/params/headPositionParam';
import { formatToISODate, yesOrNot } from 'helpers';

import { LegalClientHeadPositionFormType } from '../../forms/legalClientHeadPositionForm';

export const parseHeadPositionParam = (
  values: LegalClientHeadPositionFormType
): HeadPositionParam => {
  const result = {
    positionInCompany: values.position.position,
    isFirstHead: yesOrNot(values.position.firstHead?.value) ?? false,
    legalClientBodyIds:
      values.position.bodies
        ?.filter((v) => v.value !== '-1')
        .map((v) => v.value!) ?? [],
    expirationDate: values.position.dateOfExpiration
      ? formatToISODate(values.position.dateOfExpiration)
      : undefined,
    positionConfirmationFileIds: values.position.positionConfirmationFiles.map(
      ({ id }) => id!
    ),
    hasLegalClientBody: !values.position.bodies?.some((v) => v.value === '-1'),
  };

  return result;
};
